export const formatNumber = Intl.NumberFormat(undefined, { useGrouping: true }).format

export const formatPercentage = (numerator: number, denominator: number) => {
  const formatter = Intl.NumberFormat(undefined, { style: 'percent' }).format

  if (denominator === 0) return formatter(0) // Prevent NaN

  return formatter(numerator / denominator)
}
